import CloseIcon from '@mui/icons-material/Close';

export const SharePreviews = ({ isFetchingLink, linkPreview, files, removeFile }) => {
    return (
        <>
            {isFetchingLink && (
                <div className="fetchingLinkText">
                    Loading preview link...
                </div>
            )}

            {linkPreview && !isFetchingLink && (
                <div className="linkPreviewCard">
                    {linkPreview.img && 
                        <img src={linkPreview.img} alt="preview" />
                    }

                    <div className="linkInfo">
                        <h4>
                            {linkPreview.title}
                        </h4>

                        <p>
                            {linkPreview.description}
                        </p>
                    </div>
                </div>
            )}

            {Array.isArray(files) && files.length > 0 && (
                <div className="filePreviewGrid">
                    {files.map((file, index) =>(
                        <div className="previewItem" key={index}>
                            {file.type.startsWith("video/") ? (
                                <video src={URL.createObjectURL(file)} controls muted />
                            ) : (
                                <img src={URL.createObjectURL(file)} alt="" />
                            )}
                            <button className="removeFile" onClick={() => removeFile(index)}>
                                <CloseIcon />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};